import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    component_isRishTheory: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    renderComponent_vehicle: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
